import React from 'react'
import { GlobalStyles } from '@mui/material'
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import theme from 'utils/theme'
import '@ionic/react/css/core.css'
import '@ionic/react/css/normalize.css'
import '../../assets/fonts/index.css'

interface Props {
  children?: React.ReactNode
}

const ThemeProvider: React.FC<Props> = ({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        {/* This removes the annoying error overlay from react */}
        <GlobalStyles
          styles={{
            'iframe#webpack-dev-server-client-overlay': {
              display: 'none',
            },
          }}
        />
        {children}
      </MuiThemeProvider>
    </StyledEngineProvider>
  )
}

export default ThemeProvider
